<template>
  <div v-if="isShow">
    <div class="dialog-wrap" >
      <div class="dialog-cover mark" @click.stop="closeMyself"></div>
        <transition name="drop">
          <div class="dialog-box">
            <div>
              <div class="dialogtype">
                <div class="dialogtitle">
                  {{title}}
                  <span class="dialog-close" @click="closeMyself">&times;</span>
                </div>
                <slot>empty</slot>
              </div>
            </div>
          </div>
        </transition>
      </div>
  </div>
</template>

<script>
  export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '提示信息'
      }
    },
    methods: {
      closeMyself () {
        this.$emit('on-close')
      }
    }
  }
</script>

<style scoped >
  .dialogtitle {
    line-height: 30px;
    font-weight: bold;
    border-bottom: 1px solid #DDDDDD;

  }
  .dialogtitle .dialog-close {
      top: 5px;
      right: 10px;
   }
  .dialogtype {
    width: 350px;
    min-height: 100px;
    background: #fff;
    box-shadow: 0 0 4px rgba(0,0,0,0.2);
    position: fixed;
    left: calc(50% - 160px);
    top: 30%;
    z-index: 100;
    border-radius: 5px;
    padding: 15px;
    padding-top: 10px;
  }
  .drop-enter-active {
    transition: all .5s ease;
  }

  .drop-leave-active {
    transition: all .3s ease;
  }

  .drop-enter {
    transform: translateY(-500px);
  }

  .drop-leave-active {
    transform: translateY(-500px);
  }

  .dialog-wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99999999;
  }

  .dialog-cover {
    /* background: #0000009e; */
    /*opacity: .3;*/
    position: fixed;
    z-index: 5;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .dialog-cover.mark {
    background: #0000009e !important;
    opacity: .3 !important;
  }
  .dialog-content {
    min-width: 270px;
    position: fixed;
    max-height: 50%;
    overflow: auto;
    background: #3ca7e3;
    top: 5%;
    left: 50%;
    margin-left: -135px;
    z-index: 10;
    border: 1px solid #3ca7e3;
    color: #fff;
    padding: 0 10px;
    line-height: 1;
    border-radius: 5px;
  }

  .dialog-close {
    position: absolute;
    right: 5px;
    top: 0;
    width: 20px;
    height: 20px;
    text-align: center;
    cursor: pointer;
  }

  .dialog-close:hover {
    color: #f36709;
  }
</style>



// WEBPACK FOOTER //
// Dialogs.vue?f1969f4c